import { Injectable } from '@angular/core';
import { ToastController, LoadingController, Platform } from '@ionic/angular';
import { Constants } from '../../constants/constants'
import { Subject, Subscription } from 'rxjs';
import { LocalStorageService } from '../local-storage/local-storage.service';


@Injectable({
  providedIn: 'root'
})
export class AppearanceService {

  private eventsObservable: { [key: string]: Subject<any>; } = {};
  loading: any = null;
  loadingVisible: boolean = false;
  isCordova: boolean = false;
  public homePage: boolean = false;
  private lightsOn: boolean = false;

  private redirectToPage: string = null;
  
  constructor(private loadingCtrl: LoadingController, private toastController: ToastController,
    private platform: Platform) {

      if (this.platform.is("cordova"))
      {
        this.isCordova = true;
      }
      else
      {
        this.warningInternetExplorer();
      }

      this.listenForEvent('theme:light', (data: any) => {

        this.setTheme(true);

      });

      this.listenForEvent('theme:dark', (data: any) => {

        this.setTheme(false);
        
      });
  }


  warningInternetExplorer() 
  {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE '); // IE 10 or older
    var trident = ua.indexOf('Trident/'); //IE 11
  
    if (msie > 0 || trident > 0)
    {
      this.presentToast("Internet Explorer is not supported. Google Chrome recommended.", Constants.TOAST_INFO);
    }
  }


  listenForEvent(topic: string, observer: (_: any) => void): Subscription 
  {
    if (!this.eventsObservable[topic]) 
    {
      // You can also use ReplaySubject with one concequence
      this.eventsObservable[topic] = new Subject<any>();
    }

    return this.eventsObservable[topic].subscribe(observer);
  }


  triggerEvent(topic: string, data?: any): void 
  {
    const subject = this.eventsObservable[topic];

    if (!subject) 
    {
      // Or you can create a new subject for future subscribers
      return;
    }

    subject.next(data);
}


  stopListeningForEvent(topic: string): null 
  {
    const subject = this.eventsObservable[topic];

    if (!subject) 
    {
        return;
    }

    subject.complete();
    delete this.eventsObservable[topic];
  }


  async presentToast(message, toastType, showCloseButton=false) 
  {
    var cssClass = "";
    var toast = null;

    switch(toastType)
    {
      case Constants.TOAST_SUCCESS:
        cssClass = "toast-success";
        break;

      case Constants.TOAST_ERROR:
        cssClass = "toast-error";
        break;

      case Constants.TOAST_INFO:
        cssClass = "toast-info";
        break;
    }

    if(showCloseButton)
    {
      toast = await this.toastController.create({
        message: message,
        cssClass: cssClass,
        position: 'top',
        buttons: [
          {
            text: 'Close',
            role: 'cancel',
            handler: () => {
            }
          }
        ]
      });
    }
    else
    {
      toast = await this.toastController.create({
        message: message,
        cssClass: cssClass,
        duration: 3000,
        position: 'top',
      });
    }


    toast.present();
  }


  public async showLoading(message: string): Promise<void> 
  {
    if (!this.loadingVisible) 
    {
        this.loading = await this.loadingCtrl.create({
          message: message
        });

        this.loadingVisible = true;
        return await this.loading.present();
    } 
    else 
    {
        // If loader is showing, only change text, won't create a new loader.
        this.loadingVisible = true;
        this.loading.message = message;
    }
  }


  public async dismissLoading(): Promise<void> 
  {
      if (this.loading && this.loadingVisible) 
      {
          this.loadingVisible = false;
          await this.loading.dismiss();
      }
  }

  
  public isMobileDevice(): boolean
  {
    return this.isCordova;
  }


  setTheme(lightsOn)
  {
    this.lightsOn = lightsOn;
    
    if (!this.lightsOn)
    {
      document.body.setAttribute('data-theme', 'dark');
    }
    else
    {
      document.body.setAttribute('data-theme', 'light');
    }
  }


  toggleTheme()
  {
    this.lightsOn = !this.lightsOn;

    if (!this.lightsOn)
    {
      document.body.setAttribute('data-theme', 'dark');
    }
    else
    {
      document.body.setAttribute('data-theme', 'light');
    }
  }


  isLightThemeEnabled()
  {
    return this.lightsOn;
  }


  public setRedirectPage(route)
  {
    this.redirectToPage = route;
  }

  public getRedirectPage(): string
  {
    return this.redirectToPage;
  }
}
